import "../styles/CouponDisplay.css";
const CouponDisplay = () => {
  return (
    <div>
      <div className="displayCoupon">
      <h1>Use Code NEW100 to Get Flat ₹100 OFF </h1>
      </div>
    </div>
  )
}

export default CouponDisplay
